// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpSecondaryTabAceptarTodo extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.secondary_tab.aceptar_todo";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpSecondaryTabAceptarTodo {
        this.VALUES ??= this.completar({
            "valor": {
                "ca-ES": "D'acord amb tot",
                "cz": "Přijmout vše",
                "da": "Alles accepteren",
                "de": "Alle akzeptieren",
                "en": "Accept all",
                "eu-ES": "Onartu guztia",
                "fi": "Hyväksy kaikki",
                "fr": "Tout accepter",
                "ga-ES": "Aceptar todo",
                "hi": "सभी स्वीकार करो",
                "hu": "Mindent elfogad",
                "it": "Accettare tutto",
                "no": "Aksepter alt",
                "nl": "Alles accepteren",
                "pl": "Akceptuj wszystko",
                "pt": "Aceitar tudo",
                "ro": "Acceptă toate",
                "ru": "Принять всё",
                "sv": "Acceptera alla",
                "sk": "Prijať všetko"
            },
            "defecto": "Aceptar todo"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
